import { css } from 'linaria';
import tokens from './tokens';
import { FontSizeValues, FontWeightValues, LetterSpacingValues, TextTransformValues } from './types';

const fontWeightLight = css`
    font-weight: ${tokens.fontWeights.light};
`;

const fontWeightNormal = css`
    font-weight: ${tokens.fontWeights.normal};
`;

const fontWeightSemibold = css`
    font-weight: ${tokens.fontWeights.semibold};
`;

const fontWeightBold = css`
    font-weight: ${tokens.fontWeights.bold};
`;

const fontWeightInherit = css`
    font-weight: inherit;
`;

const fontWeightVariants: Record<FontWeightValues, string> = {
    light: fontWeightLight,
    normal: fontWeightNormal,
    semibold: fontWeightSemibold,
    bold: fontWeightBold,
    inherit: fontWeightInherit,
};

const fontSize12 = css`
    font-size: ${tokens.fontSizes['12']};
`;
const fontSize14 = css`
    font-size: ${tokens.fontSizes['14']};
`;
const fontSize16 = css`
    font-size: ${tokens.fontSizes['16']};
`;
const fontSize20 = css`
    font-size: ${tokens.fontSizes['20']};
`;
const fontSize24 = css`
    font-size: ${tokens.fontSizes['24']};
`;
const fontSize32 = css`
    font-size: ${tokens.fontSizes['32']};
`;
const fontSize48 = css`
    font-size: ${tokens.fontSizes['48']};
`;
const fontSize64 = css`
    font-size: ${tokens.fontSizes['64']};
`;

const fontSize96 = css`
    font-size: ${tokens.fontSizes['96']};
`;

const fontSizeVariants: Record<FontSizeValues, string> = {
    '12': fontSize12,
    '14': fontSize14,
    '16': fontSize16,
    '20': fontSize20,
    '24': fontSize24,
    '32': fontSize32,
    '48': fontSize48,
    '64': fontSize64,
    '96': fontSize96,
};

const textTranformCapitalize = css`
    text-transform: capitalize;
`;

const textTranformUppercase = css`
    text-transform: uppercase;
`;

const textTranformLowercase = css`
    text-transform: lowercase;
`;

const textTransformVariants: Record<TextTransformValues, string> = {
    capitalize: textTranformCapitalize,
    uppercase: textTranformUppercase,
    lowercase: textTranformLowercase,
};

const letterSpacingTighter = css`
    letter-spacing: -0.05em;
`;

const letterSpacingTigh = css`
    letter-spacing: -0.025em;
`;
const letterSpacingNormal = css`
    letter-spacing: 0;
`;
const letterSpacingWide = css`
    letter-spacing: 0.025em;
`;
const letterSpacingWider = css`
    letter-spacing: 0.05em;
`;
const letterSpacingWidest = css`
    letter-spacing: 0.1em;
`;

const letterSpacingVariants: Record<LetterSpacingValues, string> = {
    tighter: letterSpacingTighter,
    tight: letterSpacingTigh,
    normal: letterSpacingNormal,
    wide: letterSpacingWide,
    wider: letterSpacingWider,
    widest: letterSpacingWidest,
};

export default {
    fontSizeVariants,
    fontWeightVariants,
    textTransformVariants,
    letterSpacingVariants,
};
